// utils/roundPriceStep.ts
//
// Phase C: the price grid is per-currency (utils/payinConfig.ts — mirror of
// server lib/payinConfig.js). No currency argument → usd step 50 →
// BYTE-IDENTICAL to the historic half-dollar grid (13.01..13.50 → 13.5,
// 13.51..13.99 → 14). HUF (step 50 Ft) can never produce a fractional forint.
import { roundUpToStep } from "./payinConfig";

export function roundPriceStep(n: number, currency?: string | null): number {
  return roundUpToStep(n, currency);
}
